import Painel from '../views/Atendimento/Painel.vue'

let routes = {
  path: '/atendimento',
  name: 'atendimento',
  component: Painel,
  meta: {
    pageTitle: 'Atendimento',
    breadcrumb: [{ text: 'Atendimento', active: true }],
  },
}

export default routes
